import {
    SystemsFilterDefaults,
    SystemsSearchOptions,
    SystemsFilterGroups,
} from './systems-table.filters';

export const SystemsColumns = [
    {
        displayName: 'System Id',
        sortColumnName: 'systemId',
        dataType: 'string',
        dataKey: 'systemId',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-10',
    },
    {
        displayName: 'System Name',
        sortColumnName: 'systemName',
        dataType: 'string',
        dataKey: 'systemName',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-30',
    },
    {
        displayName: 'URL',
        sortColumnName: 'url',
        dataType: 'string',
        dataKey: 'url',
        settings: { sort: false, filter: false, multiple: false },
        css: 'w-40',
    },
    {
        displayName: 'Is Active',
        sortColumnName: 'isActive',
        dataType: 'indicator-chip',
        dataKey: 'isActive',
        converter: (id) =>
            id
                ? { label: { text: 'Active' }, value: 1, css: 'bg-green' }
                : { label: { text: 'Inactive' }, value: 0, css: 'bg-grey' },
        settings: { sort: true, filter: true, multiple: false },
        css: 'w-15',
    },
    {
        displayName: 'Actions',
        sortColumnName: 'actions',
        dataType: 'actions',
        dataKey: 'actions',
        settings: { sort: false, filter: false, multiple: false },
        css: 'w-5',
    },
];

export const SystemsFilters = {
    sorting: {
        sortByColumn: 'systemId',
        sortByDescending: true,
    },

    pagination: {
        paginationEvent: () => {},
        paginationData: {
            pageNumber: 1,
            pageSize: 10,
            total: 10,
        },
        pageSizeOptions: [
            { value: 5, text: '5' },
            { value: 10, text: '10' },
            { value: 25, text: '25' },
            { value: 50, text: '50' },
            { value: 100, text: '100' },
        ],
        defaultPageSize: {
            value: 10,
            text: '10',
        },
    },

    advancedFilters: {
        config: {
            searchOptions: SystemsSearchOptions,
            filterDefaults: SystemsFilterDefaults,
            defaultSearchOption: SystemsFilterDefaults.defaultSearchOption,
            filterGroups: SystemsFilterGroups,
        },
        callbacks: {
            search: (data) => {},
            filter: (data) => {},
        },
    },
};
